import { useCallback } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { useStore } from '../hooks/useStore';
import { BigPlayIcon } from '../icons';
import styles from './BigPlayButton.module.css';

export function BigPlayButton() {
  const { store, eventBus } = usePlayerContext();
  const isPlaying = useStore(store, useCallback(s => s.isPlaying, []));
  const loading = useStore(store, useCallback(s => s.loading, []));
  const isHidden = isPlaying || loading;

  const handleClick = useCallback(() => {
    if (isHidden) return;
    eventBus.emit('play');
  }, [eventBus, isHidden]);

  return (
    <div
      className={`${styles.bigPlay}${isHidden ? ` ${styles.hidden}` : ''}`}
      onClick={handleClick}
      data-overlay="big-play-button"
      data-testid="big-play-button"
    >
      <div className={styles.icon}>
        <BigPlayIcon data-testid="big-play-button-icon" />
      </div>
    </div>
  );
}
